import { createApp } from 'vue';
import App from './App.vue';

// main.js or main.ts
import 'devextreme/dist/css/dx.material.blue.light.css';

createApp(App).mount('#app');
